import React, { FunctionComponent, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useRequiredValidation } from '../../../../utils/form/validation.utils';
import { FormTextInput } from '../../common/inputs/TextInput';
import { INewUserFormProps } from './types';
import { USER_STATE, STEP } from '../../../dialogs/NewUserFormDialog';

export const NewUserForm: FunctionComponent<INewUserFormProps> = ({ onSubmit, userState, user, step }) => {
  const formProps = useForm();
  const requiredValidation = useRequiredValidation();
  const { setValue } = formProps;

  useEffect(() => {
    if (user) {
      setValue('firstName', user.firstName);
      setValue('lastName', user.lastName);
    }
  }, [user, setValue]);

  return (
    <FormProvider {...formProps}>
      <form
        id="new-user-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as any))}
        action=""
        method="post"
      >
        {userState === USER_STATE.NEW_USER && (
          <>
            <div className="col-12 mt-2" style={{ marginTop: '10px' }}>
              <div className="field-container">
                <FormTextInput
                  defaultValue={user?.firstName}
                  id="firstName"
                  name="firstName"
                  type="text"
                  label="First Name (*)"
                  placeholder="Enter First Name"
                  validation={requiredValidation}
                />
              </div>
            </div>
            <div className="col-12 mt-2">
              <div className="field-container">
                <FormTextInput
                  defaultValue={user?.lastName}
                  id="lastName"
                  name="lastName"
                  type="text"
                  label="Last Name (*)"
                  placeholder="Enter Last Name"
                  validation={requiredValidation}
                />
              </div>
            </div>
          </>
        )}
        <div className="col-12 mt-2">
          <div className="field-container" style={step === STEP.ONE ? {} : { display: 'none' }}>
            <FormTextInput
              id="email"
              name="email"
              type="email"
              label="Email (*)"
              placeholder="Enter Email"
              validation={requiredValidation}
            />
          </div>
        </div>
        <div className="col-12 mt-2">
          <div className="darkGray">(*) mandatory fields</div>
        </div>
      </form>
    </FormProvider>
  );
};
